export * from './consequences.component';
export * from './edit/edit.component';
